export const filterOptions = (allValue: string) => [
  {
    label: `All ${allValue}`,
    value: 'all',
  },
  {
    label: 'Active',
    value: 'ACTIVE',
  },
  {
    label: 'Paused',
    value: 'PAUSED',
  },
  {
    label: 'Archive',
    value: 'ARCHIVED',
  },
];

export const filterDateOptions = [
  {
    label: 'Today',
    value: () => {
      const today = new Date();
      return today.toISOString();
    },
  },
  {
    label: 'This Week',
    value: () => {
      const today = new Date();
      const day = today.getDay();
      const diff = today.getDate() - day + (day === 0 ? -6 : 1);
      const weekStart = new Date(today);
      weekStart.setDate(diff);
      return weekStart.toISOString();
    },
  },
  {
    label: 'This Month',
    value: () => {
      const today = new Date();
      return new Date(today.getFullYear(), today.getMonth(), 1).toISOString();
    },
  },
  {
    label: 'This Quarter',
    value: () => {
      const today = new Date();
      const month = today.getMonth();
      let quarterStartMonth = 0;

      if (month >= 0 && month <= 2) quarterStartMonth = 0;
      else if (month >= 3 && month <= 5) quarterStartMonth = 3;
      else if (month >= 6 && month <= 8) quarterStartMonth = 6;
      else if (month >= 9 && month <= 11) quarterStartMonth = 9;

      return new Date(today.getFullYear(), quarterStartMonth, 1).toISOString();
    },
  },
  {
    label: 'This Year',
    value: () => {
      return new Date(new Date().getFullYear(), 0, 1).toISOString();
    },
  },
  {
    label: 'This Cycle',
    value: () => {
      const today = new Date();
      const year = today.getFullYear();
      const cycleStartYear = year % 2 === 0 ? year - 1 : year;
      return new Date(cycleStartYear, 0, 1).toISOString();
    },
  },
  {
    label: 'Custom',
    value: () => {
      return new Date().toISOString();
    },
  },
];
